import React from 'react'

//components
import Worker from './Worker'

function Table(props) {
    const machines = props.machines

    return (
        <div className="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th>Име</th>
                        <th className="option">
                            Опции
                    </th>
                    </tr>
                </thead>
                <tbody>
                    {machines.map(machines =>
                        <Worker
                            worker={machines}
                            handleEdit={props.handleEdit}
                        />
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default Table